<template>
  <div>
    <slot v-if="shown"></slot>
  </div>
</template>
<script>
// Renders its content the first time its Bootstrap tab is shown, so a tab's
// lists don't load with the page. Use a v-slot template for the content so
// it isn't built until then.
export default {
  name: 'lazy-tab-pane',
  props: {
    // The pane's id, as in the tab link's href="#..."
    pane: { type: String, required: true },
  },
  data() {
    return {
      shown: false,
    };
  },
  mounted() {
    this.link = $(`a[data-toggle="tab"][href="#${this.pane}"]`);
    this.link.on('shown.bs.tab', this.show);
    if (this.link.parent().hasClass('active')) {
      this.show();
    }
  },
  destroyed() {
    this.link.off('shown.bs.tab', this.show);
  },
  methods: {
    show() {
      this.shown = true;
    },
  },
};
</script>
